import { Button } from "@/components/ui/button";
import useStages from "@/features/stage/api/useStages";
import { useAppSelector } from "@/stores/hook";
import { LinkIcon } from "lucide-react";

export function StageDrawerHeader({ count, onClick, disabled }: any) {
  const { stageId } = useAppSelector((state) => state.childFunctional);
  const { stages } = useStages();

  if (!stages || !stageId) return null;

  const stage = stages.find((stage) => stage.id === stageId);

  if (!stage) return null;

  return (
    <div className="flex items-center justify-between">
      <h1 className="text-[16px] font-medium text-[var(--color-black-10)] tracking-[-0.32px] leading-normal">
        {stage.name}
        <span className="text-[var(--color-black-5)] text-[12px] tracking-[-0.24px] leading-normal">
          ({count})
        </span>
      </h1>

      <div className="flex gap-2">
        <Button variant="ghost">
          <LinkIcon className="size-4 text-[var(--color-primary)]" />
          <span className="text-[var(--color-primary)]">Add Collaborator</span>
        </Button>
        <Button variant="primary" onClick={onClick} disabled={disabled}>
          <span>Add {stage.name}</span>
        </Button>
      </div>
    </div>
  );
}
